export enum CompareOperator {
  GreaterThan = "greaterThan",
  LessThan = "lessThan",
  EqualTo = "equalTo",
  EqualToIgnoreType = "equalToIgnoreType",
  GreaterThanOrEqualTo = "greaterThanOrEqualTo",
  LessThanOrEqualTo = "lessThanOrEqualTo",
  NotEqualTo = "notEqualTo",
}
